export default "__VITE_PUBLIC_ASSET__25a0598b__"